<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "UserOmsAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  